import { main } from './output/Gesso.Example.Timing/index.js';main();